module.exports = __webpack_public_path__ + "img/second-day-13.60466dd3.png";